/**
 * Mega Menu - Dynamic Image Switching
 * Handles hover effects for column images in mega menu
 */

(function() {
  'use strict';

  /**
   * Initialize mega menu column image switching
   * When hovering over products in a column, update the column's header image
   */
  function initColumnImageSwitch() {
    const megaMenus = document.querySelectorAll('.mega-menu');

    megaMenus.forEach(menu => {
      // Check if hover switching is enabled
      if (menu.dataset.hoverSwitch === 'false') return;

      const columns = menu.querySelectorAll('.mega-menu__column-content');

      columns.forEach(column => {
        const columnImage = column.querySelector('.mega-menu__column-image');
        const columnHeader = column.querySelector('.mega-menu__column-header');
        const defaultImageSrc = columnImage ? columnImage.dataset.defaultSrc : null;
        const productLinks = column.querySelectorAll('[data-hover-image]');

        if (!columnImage || productLinks.length === 0) return;

        // Track state to avoid unnecessary animations
        let isShowingDefault = true;

        // Function to reset image to default
        const resetToDefault = () => {
          if (!isShowingDefault && defaultImageSrc && columnImage) {
            isShowingDefault = true;
            columnImage.classList.add('is-switching');
            setTimeout(() => {
              columnImage.src = defaultImageSrc;
              setTimeout(() => {
                columnImage.classList.remove('is-switching');
              }, 50);
            }, 150);
          }
        };

        productLinks.forEach(link => {
          link.addEventListener('mouseenter', () => {
            const productImageSrc = link.dataset.hoverImage;
            if (productImageSrc && columnImage) {
              // Skip if already showing this image
              if (!isShowingDefault && columnImage.src.includes(productImageSrc.split('?')[0].split('/').pop())) {
                return;
              }

              isShowingDefault = false;
              columnImage.classList.add('is-switching');

              // Wait for fade out, then switch image
              setTimeout(() => {
                columnImage.src = productImageSrc;
                // Remove switching class after image loads
                columnImage.onload = () => {
                  columnImage.classList.remove('is-switching');
                };
                // Fallback if onload doesn't fire (cached image)
                setTimeout(() => {
                  columnImage.classList.remove('is-switching');
                }, 50);
              }, 150);
            }
          });
        });

        // Reset when hovering back on the header image
        if (columnHeader) {
          columnHeader.addEventListener('mouseenter', resetToDefault);
        }

        // Reset on mouse leave from column
        column.addEventListener('mouseleave', resetToDefault);
      });
    });
  }

  /**
   * Initialize everything when DOM is ready
   */
  function init() {
    initColumnImageSwitch();
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when Shopify section is rendered
  document.addEventListener('shopify:section:load', init);
})();
